import { Injectable } from '@angular/core'
import { NATIVE_REGION_NAMES } from './native-region-names'

@Injectable({
  providedIn: 'root',
})
export class NativeRegionNameService {
  public getNativeName(regionCode: string): string {
    return NATIVE_REGION_NAMES[regionCode] ?? regionCode
  }

  public getNativeNames(): { [regionCode: string]: string } {
    return NATIVE_REGION_NAMES
  }
}
